"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicPromoContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const c = (0, core_1.initContract)();
exports.publicPromoContract = c.router({
    getPromo: {
        method: 'POST',
        path: '/order',
        body: zod_1.z.object({
            referralId: zod_1.z.optional(zod_1.z.string()).nullable(),
            promoCode: zod_1.z.optional(zod_1.z.string()).nullable(),
            evalData: zod_1.z.optional(dbJsonModels_1.ZPromoConditions.partial()),
        }),
        responses: {
            200: zod_1.z.object({
                promoCode: zod_1.z.optional(models_1.ZPromoCodeSelect),
                message: zod_1.z.optional(zod_1.z.string()).nullable(),
                referralDetails: zod_1.z
                    .optional(zod_1.z.object({
                    firstName: zod_1.z.string(),
                    avatarLocation: zod_1.z.string().optional().nullable(),
                }))
                    .nullable(),
            }),
            400: c.type(),
        },
    },
    getFirstEntryOffer: {
        method: 'GET',
        path: '/entry-offer',
        query: zod_1.z.object({
            playerId: zod_1.z.optional(zod_1.z.string()).nullable(),
        }),
        responses: {
            200: zod_1.z.object({
                promoCode: zod_1.z.optional(models_1.ZPromoCodeSelect),
            }),
            400: c.type(),
            404: c.type(),
        },
    },
}, {
    pathPrefix: '/public',
    jsonQuery: true,
    strictStatusCodes: true,
});
//# sourceMappingURL=promo.public.contract.js.map